"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.65,11.73H22.54c-.33.55-.61,1-.74,1.17a.65.65,0,0,1-.56.3.68.68,0,0,1-.56-.3c-.08-.13-.37-.57-.73-1.17H15l-6.85,3.2H24V12A.32.32,0,0,0,23.65,11.73Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.12,11.73h0a.32.32,0,0,0-.35.27V13l2.59-1.22Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.33,15.47V24h3.41l.1,0a.28.28,0,0,0,.16-.25V15.47Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.77,15.47v8.26A.26.26,0,0,0,8,24h3.4V15.47Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "16.15 15.47 16.15 24 18.29 24 18.29 24 19.81 24 19.81 24 19.81 17.73 19.81 15.47 19.81 15.47 16.15 15.47",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "11.96 24 14.1 24 15.62 24 15.62 17.73 15.62 15.47 11.96 15.47 11.96 24",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.66,0A2.07,2.07,0,0,0,6.59,2.07c0,1.1,1.88,4,2,4.09a.14.14,0,0,0,.11.06.11.11,0,0,0,.11-.06c.08-.12,2-3,2-4.09A2.07,2.07,0,0,0,8.66,0Zm0,3a.91.91,0,1,1,.91-.91A.9.9,0,0,1,8.66,3Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.3,8.5A3.3,3.3,0,0,0,0,11.8c0,1.75,3,6.31,3.12,6.51a.21.21,0,0,0,.18.09.2.2,0,0,0,.17-.09c.13-.2,3.12-4.76,3.12-6.51A3.3,3.3,0,0,0,3.3,8.5Zm0,4.75A1.45,1.45,0,1,1,4.74,11.8,1.45,1.45,0,0,1,3.3,13.25Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.23,4.42a2.77,2.77,0,0,0-2.76,2.77c0,1.46,2.51,5.29,2.62,5.45a.15.15,0,0,0,.14.07.18.18,0,0,0,.15-.07c.1-.16,2.61-4,2.61-5.45A2.77,2.77,0,0,0,21.23,4.42Zm0,4a1.21,1.21,0,0,1,0-2.42,1.21,1.21,0,1,1,0,2.42Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.55,7.81a.53.53,0,0,1-.27-.08L11.57,4.58a.48.48,0,0,1,.53-.8l4.72,3.15a.47.47,0,0,1,.13.66A.49.49,0,0,1,16.55,7.81Z",
    fill: "#004865"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.64,14.58a.48.48,0,0,1-.2-.92L17,9.19a.49.49,0,0,1,.64.24.48.48,0,0,1-.23.64L7.85,14.53A.54.54,0,0,1,7.64,14.58Z",
    fill: "#004865"
  }));
};

exports["default"] = _default;